import OfficersTable from './OfficersTable';

export default OfficersTable;
